/** @module Sourcing/StyleSupplierRequestWizardMixIn */
define([
	"dojo/_base/declare",
	"csi/comm",
	"csi/state/rootStore",
	"csi/xml"
], function(declare,comm,{ routerStore },xml) {

	const CATEGORY1 = "Category1";
	const CATEGORY2 = "Category2";
	const COLLECTION = "Collection";
	const PARENT_SEASON = "ParentSeason";

	return declare(null, {
	/** @property {String} supplierRequestUrl - reference to supplierRequest URL */
		supplierRequestUrl: null,

		/**
		 * @override
		 * Write operation for SupplierRequestAddProduct
		 */
		toWriter: function() {
			const call = this.inherited(arguments);
			const url = comm.createUrl("SRLineItem");
			const styleUrl = this.getNodeURL();
			this.m_writer.callMethod("Sourcing", "SupplierRequestAddProduct")
				.addParameter("ParentURL", xml.ATTR_REF, this.supplierRequestUrl)
				.addParameter("URL", xml.ATTR_REF, url)
				.addParameter("FromURL", xml.ATTR_REF, styleUrl);

			return call;
		},

		/**
		 * @override
		 * Preselect the heirarchy Fields and disable it.
		 */
		onWizardViewCreate: function(wizard, page, view) {
			if (wizard.getIndexOfPage(page) == 0) {
				//Get SR Request Node
				const srNode = routerStore.getBreadcrumbNode("SupplierRequest");
				this.supplierRequestUrl = srNode.$URL;
				if (srNode) {
					view.addDefaultValue(PARENT_SEASON, srNode.SRSeason);
					view.addDefaultValue(CATEGORY1, srNode.SRCategory1);
					view.addDefaultValue(CATEGORY2, srNode.SRCategory2);
					view.addDefaultValue(COLLECTION, srNode.SRCollection);

					//Indicates if Next button will be enabled and can proceed to the next step in the case of wizard
					page.viewTab.canProceed = true;
				}
			}
		},

		/**
		 * @override
		 * Retrieve the target Navigation URL when postProcessSuccess() completes
		 * Desired destination on "Finish & Go" is to the new Style that was created.
		 * @return {String} URL of node to navigate to, or null if none
		 */
		_getNavigateNodeURL: function() {
			return this.getNodeURL();
		},

		/**
		 * @override
		 * refresh page if not navigating to newly created Style
		 */
		postProcessSuccess: function() {
			return this.bNavigate ? this.inherited(arguments) : this.widget.refreshData();
		}
	});
});